import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css']
})
export class SupportComponent implements OnInit {

  _type:string;
  _email:string;
  _content:string;

  constructor(private firestore:AngularFirestore) { 
    this._type="select";
    this._email="";
    this._content="";
  }

  ngOnInit() {

  }

  submitSupport(){
    if(this._type!="select"&&this._type!="" && this._content!=""){
      this.firestore.collection("support").add({
        type:this._type,
        email:this._email,
        content:this._content,
        isAnswered:false
      }).then(_success=>{
        this.firestore.collection("support").doc(_success.id)
      }).then(_success2=>{
        alert("Your message has been successfully received.")
      })
    }else{
      alert("Please check inputs again.");
    }
  }
}
